export const EVENTS = {
  OPT_IN: "Opt In"
};
